import { Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import { MessageAssistanceService } from './service/message-tasa-assistance.service';
import { ChangeDetectorRef } from '@angular/core';
import { env, python_tasa } from 'src/environments/environments';
import { SimpleUserData } from 'src/app/core/auth/authData.model';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Observable } from 'rxjs';
import { AlertService } from 'src/app/services/alerts.service';
import { Binary } from '@angular/compiler';
import { ApiResponse } from './interface/response-tasa-agent-API.interface';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { take } from 'rxjs/operators';
import Swal from 'sweetalert2';

// ========== INTERFACES ==========
interface N8nResponse {
    success: boolean;
    message: string;
    data: N8nResponseData;
}

interface N8nResponseData {
    output: string;
    base64?: string;
    mimeType?: string;
}

interface ChatMessage {
    sender: 'user' | 'bot';
    message: string;
    audio?: boolean;
    audioUrl?: string;
    file?: {
        name: string;
        size: number;
        type: string;
        url: string;
        icon: string;
    };
    timestamp?: Date;
}

@Component({
    selector: 'app-chat-tasa-layout-assistance',
    templateUrl: './chat-tasa-layout-assistance.component.html',
    styleUrl: './chat-tasa-layout-assistance.component.scss',
})
export class ChatTasaLayoutAssistanceComponent {

    // ==========  CONFIGURACIÓN CRÍTICA DE SEGURIDAD ==========
    //  CAMBIAR A true EN PRODUCCIÓN
    private readonly REQUIRE_TOKEN_ALWAYS = true;

    /* ============== ATRIBUTES ============== */
    userData?: SimpleUserData;
    hasAccess$: Observable<boolean>;

    selectedFile: File | null = null;
    fileTypeOpt: { [key: string]: string } = {
        'application/pdf': 'assets/icons/home/pdf_filetype_icon.svg',
        'text/plain': 'assets/icons/home/txt_filetype_icon.svg',
        'application/msword': 'assets/icons/home/doc_filetype_icon.svg',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            'assets/icons/home/doc_filetype_icon.svg',
    };
    fileType: string = '';

    messages: ChatMessage[] = [];
    newMessageUser: string = '';
    errorMessages: string[] = [];

    isThinking: boolean = false;
    isTyping: boolean = false;
    inputOn: boolean = false;

    speak: boolean = false;
    showAudio: string = 'no';

    stream: MediaStream | null = null;
    mediaRecorder: MediaRecorder | null = null;
    isRecording: boolean = false;
    audioChunks: Blob[] = [];
    title = 'Tasa de convivencia y seguridad ciudadana';

    idCliente: string = 'no';
    thread_id: string = 'nada';

    ind: number = 29;
    audio_nom: string = 'no';
    volumeUp: string = 'no';
    humanOn: string = 'no';
    espqr: string = 'no';

    asistenteIdOpenIa: string = 'asst_T6xPCHboGUCjQv0C5tfw3dxT';
    instrucciones: string = 'INSTR_VALOR_MAS';
    id_asistente: string = '5';
    empresa_modelo: string = 'OpenAI';
    ruta_script: string = '/var/www/cobra/DESARROLLO/valormas/ejecutable_valormas.sh';

    isOverflowing: boolean = true;
    isProcessingMic = false;
    isWaitingForAIResponse = false;
    lastMicClickTime: number = 0;
    micDebounceTime: number = 1000;
    readonly MAX_MESSAGE_LENGTH: number = 1000;
    recordingTime: number = 0;
    recordingInterval: any;
    isCancellingRecording: boolean = false;

    chatSessionId: string = '';

    private isEmbedded: boolean = false;
    private parentDomain: string = '';

    private tokenExpirationTime: number = 0;
    private tokenRenewalTimer: any;
    private readonly TOKEN_RENEWAL_MARGIN = 5 * 60 * 1000; // 5 minutos

    private readonly ALLOWED_PARENT_ORIGINS = [
    'https://dev.ayuda.catastroantioquia-mas.com',
    'https://pre.ayuda.catastroantioquia-mas.com',
    'https://dev.cic-ware.com',
    'https://cic-ware.com',
    'https://www.cic-ware.com',
    'https://dev2.ayuda.catastroantioquia-mas.com',
    'https://dev.tasa-chat.valormas.gov.co',
    'https://pru.tasa-chat.valormas.gov.co',
    'https://tasa-chat.valormas.gov.co',
    'http://54.145.182.117',
    'https://anttest.valormas.gov.co',
    'http://localhost:4200',
    'https://www.antioquia.gov.co',
    'https://antioquia.gov.co',
    'https://tasaseguridad.antioquia.gov.co'
];

    @ViewChild('chatbox') chatbox!: ElementRef;
    @ViewChild('messageInput') messageInput!: ElementRef;
    @ViewChild('chatSection') chatSection!: ElementRef;
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

    /* ============== CONSTRUCTOR ============== */
    constructor(
        private titleService: Title,
        private messageAssistanceService: MessageAssistanceService,
        private cdr: ChangeDetectorRef,
        public authService: AuthService,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private location: Location
    ) {
        this.messages = [];
        this.hasAccess$ = this.authService.getAccessStatus();
    }

        ngOnInit(): void {
        this.titleService.setTitle(this.title);

        this.isEmbedded = this.checkIfEmbedded();

        if (!this.isEmbedded) {
            this.blockAccessWithoutToken();
            return;
        }

        this.validateParentDomain();

        try {
            this.userData = JSON.parse(sessionStorage.getItem('user') || '{}');
        } catch (error) {
            this.userData = {};
        }

        this.chatSessionId = this.messageAssistanceService.getOrCreateSessionId();

        const storedToken = sessionStorage.getItem('embed_token');

        if (storedToken && storedToken.length > 20) {
            if (!this.isValidTokenFormat(storedToken)) {
                sessionStorage.removeItem('embed_token');
                this.blockAccessWithoutToken();
                return;
            }
            this.validateStoredToken(storedToken);
            return;
        }

        this.route.queryParams.pipe(take(1)).subscribe(params => {
            const tokenFromUrl = params['token'];

            if (this.REQUIRE_TOKEN_ALWAYS) {
                if (!tokenFromUrl) {
                    this.blockAccessWithoutToken();
                    return;
                }

                if (!this.isValidTokenFormat(tokenFromUrl)) {
                    this.blockAccessWithoutToken();
                    return;
                }

                sessionStorage.setItem('embed_token', tokenFromUrl);

                this.location.replaceState('/chat-tasa');
                this.initializeEmbeddedMode(tokenFromUrl, params);
            } else {
                if (tokenFromUrl) {
                    if (!this.isValidTokenFormat(tokenFromUrl)) {
                        this.blockAccessWithoutToken();
                        return;
                    }
                    sessionStorage.setItem('embed_token', tokenFromUrl);
                    this.location.replaceState('/chat-tasa');
                    this.initializeEmbeddedMode(tokenFromUrl, params);
                } else {
                    this.initializeNormalMode();
                }
            }
        });
    }


    ngAfterViewChecked() {
        if (this.isNearBottom()) {
            this.scrollToBottom();
        }
    }

    ngAfterViewInit() {
        this.scrollToBottom();
    }

ngOnDestroy() {
    if (this.tokenRenewalTimer) {
        clearTimeout(this.tokenRenewalTimer);
        this.tokenRenewalTimer = null;
    }

    // Limpiar intervalo de grabación
    if (this.recordingInterval) {
        clearInterval(this.recordingInterval);
        this.recordingInterval = null;
    }

    const wasRecording = this.isRecording;
    const hadStream = !!this.stream;

    // Resetear estados
    this.isWaitingForAIResponse = false;
    this.isProcessingMic = false;
    this.isRecording = false;
    this.isTyping = false;
    this.isThinking = false;

    if (wasRecording && this.mediaRecorder) {
        try {
            if (this.mediaRecorder.state === 'recording') {
                this.mediaRecorder.stop();
            }
        } catch (error) {
        }
    }

    if (hadStream && this.stream) {
        try {
            this.stream.getTracks().forEach(track => {
                if (track.readyState === 'live') {
                    track.stop();
                }
            });
        } catch (error) {
            // Error handled silently
        }
    }

    // Limpiar URLs de blob de audio
    this.messages.forEach(message => {
        if (message.audioUrl && message.audioUrl.startsWith('blob:')) {
            URL.revokeObjectURL(message.audioUrl);
        }
    });

    // Limpiar referencias
    this.stream = null;
    this.mediaRecorder = null;
    this.audioChunks = [];
}

    /**
     * 🔒 Verifica si el componente está corriendo dentro de un iframe
     */
    private checkIfEmbedded(): boolean {
        try {
            return window.self !== window.top;
        } catch (e) {
            // Si hay error al acceder a window.top, probablemente es por
            // política de same-origin, lo que significa que SÍ está en iframe
            return true;
        }
    }

    /**
     * 🔒 Valida que el dominio padre sea uno de los permitidos
     */
    private validateParentDomain(): void {
        try {
            const parentUrl = document.referrer;

            if (!parentUrl) {
                console.warn(' No se pudo obtener el dominio padre');
                return;
            }

            this.parentDomain = new URL(parentUrl).hostname;

        } catch (error) {
            console.error('Error validando dominio padre:', error);
        }
    }

    private isValidTokenFormat(token: string): boolean {
        const parts = token.split('.');
        return parts.length === 3 && token.length > 50;
    }


    @HostListener('window:beforeunload', ['$event'])
    preventDirectAccess(event: BeforeUnloadEvent): void {
        if (!this.isEmbedded) {
            sessionStorage.removeItem('embed_token');
        }
    }


@HostListener('window:message', ['$event'])
handlePostMessage(event: MessageEvent): void {
    // Solo aceptar mensajes del dominio padre autorizado
    const token = sessionStorage.getItem('embed_token');

    if (!token) {
        console.warn('Mensaje recibido sin token válido');
        return;
    }

    // 🔒 SEGURIDAD: Validar origen en producción (descomentar según necesidad)

    if (!this.ALLOWED_PARENT_ORIGINS.includes(event.origin)) {
        console.warn(' Mensaje de origen no autorizado:', event.origin);
        return;
    }


    // 🆕 MANEJAR RECEPCIÓN DE NUEVO TOKEN
    if (event.data?.type === 'TASA_CHAT_NEW_TOKEN') {
        this.handleNewToken(event.data.token);
        return;
    }

    // Mantener lógica existente
    if (event.data?.action === 'closeChat') {
        this.handleSecureClose();
    }
}

    /**
     * Cierre seguro del chat
     */
    private handleSecureClose(): void {
        // Limpiar datos sensibles antes de cerrar
        sessionStorage.removeItem('embed_token');
        this.messages = [];
        this.thread_id = 'nada';
        this.chatSessionId = '';
    }



    canSendMessage(): boolean {
        return !this.isThinking && !this.isTyping && !this.isWaitingForAIResponse;
    }

    private initializeNormalMode(): void {
        if (!this.REQUIRE_TOKEN_ALWAYS) {
            this.inputOn = true;
            this.addWelcomeMessage();
        } else {
            this.blockAccessWithoutToken();
        }
    }

    private validateStoredToken(token: string): void {

        this.inputOn = false;
        this.isThinking = true;
        this.messages = [];

        this.messageAssistanceService.validateEmbeddedToken(token).subscribe({
            next: (result) => {
                if (result.success) {
                    this.onTokenValidationSuccess(result.data);
                } else {
                    console.warn('⚠️ Token almacenado inválido, limpiando...');
                    sessionStorage.removeItem('embed_token');
                    this.onTokenValidationFailure(result.message);
                }
            },
            error: (error) => {
                sessionStorage.removeItem('embed_token');
                this.onTokenValidationFailure('Error al validar el token almacenado');
            }
        });
    }

    private initializeEmbeddedMode(token: string, params: any): void {

        this.inputOn = false;
        this.isThinking = true;
        this.messages = [];

        this.messages.push({
            sender: 'bot',
            message: '🔐 Validando acceso...',
            audio: false,
            timestamp: new Date()
        });
        this.cdr.detectChanges();

        this.parseEmbeddedConfig(params);
        this.validateEmbeddedToken(token);
    }

    private parseEmbeddedConfig(params: any): void {
        const audioParam = params['audio'];

        if (audioParam === 'true') {
            this.speak = true;
            this.volumeUp = 'si';
            this.humanOn = 'si';
        } else if (audioParam === 'false') {
            this.speak = false;
            this.volumeUp = 'no';
            this.humanOn = 'no';
        }
    }

    private validateEmbeddedToken(token: string): void {
        this.messageAssistanceService.validateEmbeddedToken(token).subscribe({
            next: (result) => {
                if (result.success) {
                    this.onTokenValidationSuccess(result.data);
                } else {
                    this.onTokenValidationFailure(result.message);
                }
            },
            error: (error) => {
                this.onTokenValidationFailure('Error al validar el token');
            }
        });
    }
private onTokenValidationSuccess(tokenData: any): void {
    this.inputOn = true;
    this.isThinking = false;
    this.messages = [];

    const config = this.messageAssistanceService.processTokenConfiguration(tokenData);

    this.idCliente = config.clientId;
    this.speak = config.audioEnabled;
    this.volumeUp = this.speak ? 'si' : 'no';
    this.humanOn = this.speak ? 'si' : 'no';

    if (tokenData.expiresAt) {
        try {
            let expirationDate;

            // Manejar diferentes formatos de fecha
            if (typeof tokenData.expiresAt === 'string') {
                expirationDate = new Date(tokenData.expiresAt);
            } else if (typeof tokenData.expiresAt === 'number') {
                // Si viene como timestamp Unix
                expirationDate = new Date(tokenData.expiresAt * 1000);
            }

            if (expirationDate && !isNaN(expirationDate.getTime())) {
                this.tokenExpirationTime = expirationDate.getTime();

                this.scheduleTokenRenewal();
            } else {
                console.warn(' Fecha de expiración inválida');
            }
        } catch (error) {
            console.error('Error procesando fecha de expiración:', error);
        }
    } else {
        console.warn(' Token sin fecha de expiración');
    }

    this.addWelcomeMessage(config.welcomeMessage);
    this.cdr.detectChanges();
}



private scheduleTokenRenewal(): void {
    if (this.tokenRenewalTimer) {
        clearTimeout(this.tokenRenewalTimer);
        this.tokenRenewalTimer = null;
    }

    if (!this.tokenExpirationTime) {
        console.warn(' No hay tiempo de expiración configurado');
        return;
    }

    const now = Date.now();
    const timeUntilExpiration = this.tokenExpirationTime - now;
    const renewalTime = timeUntilExpiration - this.TOKEN_RENEWAL_MARGIN;

    if (renewalTime <= 0) {
        console.log(' Token próximo a expirar, solicitando renovación inmediata...');
        this.requestTokenRenewal();
    } else {
        const minutesUntilRenewal = Math.round(renewalTime / 60000);
        console.log(` Renovación programada en ${minutesUntilRenewal} minutos`);

        this.tokenRenewalTimer = setTimeout(() => {
            this.requestTokenRenewal();
        }, renewalTime);
    }
}
private requestTokenRenewal(): void {
    try {
        // Enviar mensaje al iframe padre
        window.parent.postMessage({
            type: 'TASA_CHAT_TOKEN_RENEWAL_REQUEST',
            timestamp: Date.now(),
            chatSessionId: this.chatSessionId
        }, '*'); // En producción: especificar origen exacto

        // Mostrar indicador discreto (opcional)
        this.showRenewalIndicator();

    } catch (error) {
        console.error(' Error solicitando renovación:', error);
        this.handleRenewalFailure();
    }
}
private handleNewToken(newToken: string): void {

    // Validar formato
    if (!newToken || !this.isValidTokenFormat(newToken)) {
        console.error('Token recibido inválido');
        this.handleRenewalFailure();
        return;
    }

    // Guardar nuevo token
    sessionStorage.setItem('embed_token', newToken);

    // Validar con backend
    this.messageAssistanceService.validateEmbeddedToken(newToken).subscribe({
        next: (result) => {
            if (result.success && result.data) {
                console.log('✅ Nuevo token validado exitosamente');

                // Actualizar tiempo de expiración
                if (result.data.expiresAt) {
                    try {
                        let expirationDate;
                        if (typeof result.data.expiresAt === 'string') {
                            expirationDate = new Date(result.data.expiresAt);
                        } else if (typeof result.data.expiresAt === 'number') {
                            expirationDate = new Date(result.data.expiresAt * 1000);
                        }

                        if (expirationDate && !isNaN(expirationDate.getTime())) {
                            this.tokenExpirationTime = expirationDate.getTime();
                            console.log(`⏰ Nuevo token expira: ${expirationDate.toLocaleString()}`);

                            // Re-programar siguiente renovación
                            this.scheduleTokenRenewal();

                            // Notificación de éxito (opcional)
                            this.showRenewalSuccess();
                        }
                    } catch (error) {
                        console.error('❌ Error procesando fecha:', error);
                    }
                }
            } else {
                console.error('❌ Validación falló:', result.message);
                this.handleRenewalFailure();
            }
        },
        error: (error) => {
            console.error('❌ Error validando token:', error);
            this.handleRenewalFailure();
        }
    });
}
private showRenewalIndicator(): void {
    const indicator = document.createElement('div');
    indicator.id = 'token-renewal-indicator';
    indicator.innerHTML = '🔄 Renovando sesión...';
    indicator.style.cssText = `
        position: fixed;
        top: 10px;
        right: 10px;
        background: linear-gradient(135deg, #1d8549 0%, #26a65b 100%);
        color: white;
        padding: 8px 15px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 500;
        z-index: 10000;
        opacity: 0.95;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    `;
    document.body.appendChild(indicator);

    // Remover después de 3 segundos
    setTimeout(() => {
        const el = document.getElementById('token-renewal-indicator');
        if (el) el.remove();
    }, 3000);
}

private showRenewalSuccess(): void {
    const success = document.createElement('div');
    success.innerHTML = '✅ Sesión renovada';
    success.style.cssText = `
        position: fixed;
        top: 10px;
        right: 10px;
        background: linear-gradient(135deg, #1d8549 0%, #26a65b 100%);
        color: white;
        padding: 8px 15px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 500;
        z-index: 10000;
        opacity: 0.95;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    `;
    document.body.appendChild(success);

    setTimeout(() => success.remove(), 2000);
}

private handleRenewalFailure(): void {
    console.error('❌ Falló la renovación del token');

    // Deshabilitar input temporalmente
    this.inputOn = false;

    Swal.fire({
        icon: 'warning',
        title: 'Sesión Expirando',
        html: `
            <div style="text-align: center;">
                <p style="margin-bottom: 15px;">Tu sesión está por expirar.</p>
                <p style="font-size: 14px; color: #666;">
                    La página se recargará automáticamente.
                </p>
            </div>
        `,
        confirmButtonColor: '#1d8549',
        confirmButtonText: 'Recargar ahora',
        allowOutsideClick: false,
        timer: 5000,
        timerProgressBar: true
    }).then(() => {
        // Limpiar y notificar al padre
        sessionStorage.removeItem('embed_token');
        window.parent.postMessage({
            type: 'TASA_CHAT_SESSION_EXPIRED',
            timestamp: Date.now()
        }, '*');

        // Recargar después de 1 segundo
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    });
}

    private onTokenValidationFailure(reason: string): void {
        console.error('Token inválido:', reason);

        sessionStorage.removeItem('embed_token');
        sessionStorage.removeItem('chat_session_id');

        this.blockEmbeddedAccess(`Token inválido: ${reason}`);
    }

private blockEmbeddedAccess(reason: string): void {
    this.inputOn = false;
    this.isThinking = false;
    this.messages = [];

    this.messages.push({
        sender: 'bot',
        message: `
            <div style="
                text-align: center;
                padding: 50px 25px;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
            ">

                <div style="font-size: 90px; margin-bottom: 35px;">⏰</div>

                <h2 style="
                    color: #1d8549;
                    font-size: 26px;
                    font-weight: 700;
                    margin-bottom: 40px;
                    line-height: 1.3;
                ">
                    Tu sesión terminó
                </h2>

                <!-- Instrucción principal -->
                <div style="
                    background: #1d8549;
                    color: white;
                    padding: 35px 30px;
                    border-radius: 18px;
                    max-width: 480px;
                    margin: 0 auto 30px;
                    box-shadow: 0 10px 30px rgba(29, 133, 73, 0.35);
                ">
                    <p style="
                        font-size: 22px;
                        font-weight: 700;
                        margin: 0 0 25px 0;
                    ">
                        🔄 Recarga la página para continuar
                    </p>

                    <!-- Opciones simples -->
                    <div style="
                        background: rgba(255,255,255,0.2);
                        padding: 20px;
                        border-radius: 12px;
                        margin-bottom: 15px;
                    ">
                        <p style="font-size: 18px; margin: 0; font-weight: 600;">
                            🖱️ Haz clic en el botón ↻
                        </p>
                        <p style="font-size: 14px; margin: 8px 0 0 0; opacity: 0.9;">
                            (arriba en tu navegador)
                        </p>
                    </div>

                    <div style="
                        background: rgba(255,255,255,0.2);
                        padding: 20px;
                        border-radius: 12px;
                    ">
                        <p style="font-size: 18px; margin: 0; font-weight: 600;">
                            ⌨️ o presiona la tecla
                            <span style="
                                background: rgba(255,255,255,0.3);
                                padding: 4px 12px;
                                border-radius: 6px;
                                font-size: 20px;
                                display: inline-block;
                                margin: 5px;
                            ">F5</span>
                        </p>
                    </div>
                </div>

            </div>
        `,
        audio: false,
        timestamp: new Date()
    });

    this.cdr.detectChanges();
    this.scrollToBottom();
}

    private blockAccessWithoutToken(): void {
        console.warn(' Acceso bloqueado: Se requiere token');

        this.inputOn = false;
        this.isThinking = false;
        this.messages = [];

        this.messages.push({
            sender: 'bot',
            message: `
                <div style="text-align: center; padding: 30px 20px;">
                    <div style="font-size: 48px; margin-bottom: 20px;">🔒</div>
                    <h2 style="color: #d32f2f; margin-bottom: 20px;">Acceso Restringido</h2>
                    <div style="background: #fff3cd; border-left: 4px solid #ffc107; padding: 15px; margin: 20px 0; text-align: left;">
                        <strong>⚠️ Token de Autorización Requerido</strong>
                        <p style="margin: 10px 0 0 0; color: #856404;">
                            Este chat requiere un token JWT válido para funcionar.
                        </p>
                    </div>
                    <div style="background: #f8f9fa; padding: 20px; border-radius: 8px; margin-top: 25px;">
                        <p style="font-size: 14px; color: #495057; margin: 0 0 15px 0;">
                            <strong>¿Eres administrador?</strong>
                        </p>
                        <ol style="text-align: left; color: #6c757d; font-size: 13px; padding-left: 20px;">
                            <li>Accede al panel de administración</li>
                            <li>Genera un nuevo token JWT</li>
                            <li>Embebe el chat con el token proporcionado</li>
                        </ol>
                    </div>
                </div>
            `,
            audio: false,
            timestamp: new Date()
        });

        this.cdr.detectChanges();
        this.scrollToBottom();
    }

    private addWelcomeMessage(customMessage?: string): void {
        setTimeout(() => {
            const welcomeMessage: ChatMessage = {
                sender: 'bot',
                message: customMessage || 'Hola! Soy tu asistente de TASA. ¿En qué puedo ayudarte hoy?',
                audio: false,
                timestamp: new Date()
            };
            this.messages.push(welcomeMessage);
            this.scrollToBottom();
            this.cdr.detectChanges();
        }, 1000);
    }

    // ========== ENVÍO DE MENSAJES ==========

    sendMessage() {
        if (!this.canSendMessage()) {
            return;
        }

        if (!this.inputOn) {
            this.alertService.showAlert(
                'No puedes enviar mensajes. Se requiere un token válido.',
                'error'
            );
            return;
        }

        if (this.selectedFile) {
            this.alertService.showAlert(
                'El envío de archivos no está disponible. Solo se procesará el mensaje de texto.',
                'warning'
            );
            this.clearFile();
        }

        if (this.newMessageUser.trim() !== '') {
            this.messages.push({
                sender: 'user',
                message: this.newMessageUser,
                timestamp: new Date()
            });

            const userMessage = this.newMessageUser.trim();
            this.newMessageUser = '';

            if (this.messageInput && this.messageInput.nativeElement) {
                const textarea = this.messageInput.nativeElement;
                textarea.value = '';
                textarea.style.height = '38px';
                textarea.rows = 1;
                textarea.scrollTop = 0;
            }

            this.isThinking = true;
            this.isWaitingForAIResponse = true;
            this.cdr.detectChanges();
            this.scrollToBottom();

            this.sendMessageToN8n(userMessage);
        }
    }

    private sendMessageToN8n(message: string) {
        if (!this.chatSessionId) {
            this.chatSessionId = this.messageAssistanceService.getOrCreateSessionId();
        }

        const n8nData = {
            sessionId: this.chatSessionId,
            pregunta: message,
            audio_enabled: this.speak
        };

        this.messageAssistanceService.sendMessageN8n2(n8nData).subscribe({
            next: (response: N8nResponse) => {
                this.isWaitingForAIResponse = false;
                this.isProcessingMic = false;
                this.isThinking = false;

                if (response && response.success && response.data) {
                    const formattedResponse = this.formatearRespuestaN8n(response.data.output);

                    let audioUrl: string | undefined = undefined;
                    let hasAudio = false;

                    if (this.speak && response.data.base64 && response.data.mimeType) {
                        try {
                            audioUrl = this.convertBase64ToAudioUrl(
                                response.data.base64,
                                response.data.mimeType
                            );
                            hasAudio = true;
                        } catch (error) {
                            console.error('Error convirtiendo audio:', error);
                        }
                    }

                    this.displayMessageWithTypingEffect(
                        formattedResponse,
                        'bot',
                        hasAudio,
                        audioUrl
                    );

                    this.scrollToBottom();
                } else {
                    this.mostrarErrorAleatorio();
                }
            },
            error: (error) => {
                this.isWaitingForAIResponse = false;
                this.isProcessingMic = false;
                this.isThinking = false;
                this.mostrarErrorAleatorio();
            }
        });
    }

    // ========== GRABACIÓN ==========

    toggleRecording() {
        if (!this.inputOn) {
            this.alertService.showAlert(
                'El micrófono no está disponible. Se requiere un token válido.',
                'error'
            );
            return;
        }

        const currentTime = Date.now();
        if (currentTime - this.lastMicClickTime < 1500) {
            return;
        }
        this.lastMicClickTime = currentTime;

        if (this.isProcessingMic || this.isWaitingForAIResponse || this.isThinking || this.isTyping) {
            return;
        }

        if (this.isRecording) {
            this.isProcessingMic = true;
            this.stopRecording();
        } else {
            this.isProcessingMic = true;
            this.startRecording();
        }
    }

    toggleSpeak() {
        this.speak = !this.speak;
        if (!this.speak) {
            this.volumeUp = 'no';
            this.humanOn = 'no';
        } else {
            this.volumeUp = 'si';
            this.humanOn = 'si';
        }
    }

    // ========== MÉTODOS AUXILIARES ==========

    private convertBase64ToAudioUrl(base64Audio: string, mimeType: string): string {
        try {
            if (!base64Audio || base64Audio.length < 100) {
                throw new Error('Base64 de audio inválido');
            }

            const validMimeType = mimeType || 'audio/mp3';

            let base64Data = base64Audio;
            if (!base64Audio.startsWith('data:')) {
                base64Data = `data:${validMimeType};base64,${base64Audio}`;
            }

            const base64Content = base64Data.split(',')[1];
            if (!base64Content) {
                throw new Error('No se pudo extraer el contenido base64');
            }

            const byteCharacters = atob(base64Content);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const audioBlob = new Blob([byteArray], { type: validMimeType });

            if (audioBlob.size === 0) {
                throw new Error('El blob de audio está vacío');
            }

            return URL.createObjectURL(audioBlob);

        } catch (error) {
            throw error;
        }
    }

    private formatearRespuestaN8n(output: string): string {
        if (!output) return 'Lo siento, no pude procesar tu mensaje. Intenta de nuevo.';

        return output
            .replace(/\s{2,}/g, '<br>')
            .replace(/\n+/g, '<br>')
            .replace(/\\n/g, '<br>')
            .replace(/\\r\\n/g, '<br>')
            .replace(/\\r/g, '<br>')
            .replace(/【[^】]*】/g, '')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/<br>-\s+(.+)/g, '<br>• $1')
            .replace(/^-\s+(.+)/gm, '• $1')
            .replace(
                /(https?:\/\/[a-zA-Z0-9\-._~:/?#@!'()*+,;=%]+)/g,
                '<a class="text-blue-600 underline hover:text-blue-800" href="$1" target="_blank">$1</a>'
            )
            .replace(/(<br>\s*){3,}/g, '<br><br>')
            .replace(/^(<br>\s*)+/, '')
            .trim();
    }

    displayMessageWithTypingEffect(
        message: string,
        type: 'user' | 'bot',
        audio: boolean,
        audioUrlSrc?: string
    ) {
        this.isThinking = false;
        this.isTyping = true;
        this.isWaitingForAIResponse = true;

        const newMessage: ChatMessage = {
            sender: type,
            message: '',
            audio: audio,
            audioUrl: audioUrlSrc,
            timestamp: new Date()
        };
        this.messages.push(newMessage);

        let i = 0;
        let intervalId: any;
        let lastTime = Date.now();
        const typingSpeed = 25;

        const typeWriter = () => {
            const currentTime = Date.now();
            const elapsedTime = currentTime - lastTime;
            const charsToAdd = Math.floor(elapsedTime / typingSpeed);

            if (charsToAdd > 0 && i < message.length) {
                const endIndex = Math.min(i + charsToAdd, message.length);
                newMessage.message += message.substring(i, endIndex);
                i = endIndex;
                lastTime = currentTime;

                if (this.isNearBottom()) {
                    this.scrollToBottom();
                }

                if (i >= message.length) {
                    this.isTyping = false;
                    this.isThinking = false;
                    this.isWaitingForAIResponse = false;
                    clearInterval(intervalId);
                }
            }
        };

        intervalId = setInterval(typeWriter, 25);
    }

    private mostrarErrorAleatorio() {
        setTimeout(() => {
            const MsgAleatorio = this.MensajesError();
            this.displayMessageWithTypingEffect(
                MsgAleatorio,
                'bot',
                false,
                undefined
            );
            this.scrollToBottom();
        }, 2000);
    }

    MensajesError() {
        const errorMessages: string[] = [
            'Oops, parece que algo salió mal 🙃 ¡Intentémoslo de nuevo!',
            'Ups, algo no fue como esperábamos 🧐 ¿Lo intentamos otra vez?',
            'Parece que se nos cayó el mensaje 🛠, pero lo intentamos de nuevo!',
            '¡Vaya! Este mensaje decidió tomarse un descanso 😅 ¡Prueba enviarlo otra vez!',
            'El mensaje no quiso salir 🤷‍♀, pero lo intentamos una vez más.',
        ];

        const randomIndex = Math.floor(Math.random() * errorMessages.length);
        return errorMessages[randomIndex];
    }

    handleKeyPress(event: KeyboardEvent) {
        if (
            event.key === 'Enter' &&
            this.newMessageUser.trim() !== '' &&
            this.canSendMessage()
        ) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    autoResize(event: Event) {
        const textarea = event.target as HTMLTextAreaElement;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
        this.isOverflowing = textarea.scrollHeight > textarea.clientHeight;
    }

    cancelRecording(): void {
        if (!this.isRecording) {
            return;
        }
        this.isCancellingRecording = true;
        if (this.recordingInterval) {
            clearInterval(this.recordingInterval);
            this.recordingInterval = null;
        }
        this.audioChunks = [];
        if (this.mediaRecorder) {
            try {
                if (this.mediaRecorder.state === 'recording') {
                    this.mediaRecorder.stop();
                }
            } catch (error) {
                console.error('Error deteniendo MediaRecorder:', error);
            }
        }
        if (this.stream) {
            this.stream.getTracks().forEach(track => {
                try {
                    track.stop();
                } catch (error) {
                    console.error('Error deteniendo track:', error);
                }
            });
            this.stream = null;
        }
        this.isRecording = false;
        this.isProcessingMic = false;
        this.isWaitingForAIResponse = false;
        this.recordingTime = 0;
        this.mediaRecorder = null;
        Swal.fire({
            icon: 'info',
            title: 'Grabación cancelada',
            text: 'El audio no fue enviado.',
            confirmButtonColor: '#1d8549',
            confirmButtonText: 'Entendido',
            timer: 2000,
            timerProgressBar: true
        });
        setTimeout(() => {
            this.isCancellingRecording = false;
        }, 1000);
        this.cdr.detectChanges();
    }

    stopRecording() {
        if (!this.mediaRecorder || !this.isRecording) {
            this.isProcessingMic = false;
            return;
        }
        if (this.recordingInterval) {
            clearInterval(this.recordingInterval);
            this.recordingInterval = null;
        }
        try {
            this.isRecording = false;
            this.mediaRecorder.stop();
            this.isWaitingForAIResponse = true;
        } catch (error) {
            this.isRecording = false;
            this.isProcessingMic = false;
            this.isWaitingForAIResponse = false;
            Swal.fire({
                icon: 'error',
                title: 'Error al grabar',
                text: 'Ocurrió un error al procesar el audio.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Entendido'
            });
        }
        setTimeout(() => {
            if (this.stream) {
                try {
                    this.stream.getTracks().forEach(track => {
                        track.stop();
                    });
                    this.stream = null;
                } catch (error) {
                }
            }
        }, 500);
    }

    startRecording() {
        if (!this.inputOn) {
            Swal.fire({
                icon: 'error',
                title: 'Sesión Inválida',
                text: 'No puedes grabar audio sin un token válido.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Entendido'
            });
            this.isProcessingMic = false;
            return;
        }

        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            Swal.fire({
                icon: 'error',
                title: 'Navegador incompatible',
                text: 'Tu navegador no soporta grabación de audio.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Entendido'
            });
            this.isProcessingMic = false;
            return;
        }

        if (this.isRecording || this.mediaRecorder) {
            this.stopRecording();
        }

        navigator.mediaDevices.getUserMedia({ audio: true })
            .then((stream) => {
                this.stream = stream;
                this.audioChunks = [];

                try {
                    const isIOS = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);
                    let options = {};
                    let fileExtension = '.webm';

                    const mimeTypes = isIOS
                        ? ['audio/mp4', 'audio/aac', 'audio/wav']
                        : ['audio/webm', 'audio/ogg', 'audio/wav'];

                    for (const type of mimeTypes) {
                        if (MediaRecorder.isTypeSupported(type)) {
                            options = { mimeType: type };
                            fileExtension = type.includes('webm') ? '.webm' :
                                type.includes('ogg') ? '.ogg' :
                                    type.includes('mp4') ? '.mp4' :
                                        type.includes('aac') ? '.aac' : '.wav';
                            break;
                        }
                    }

                    const maxRecordingDuration = 60000;
                    let recordingTimeout: any;

                    this.mediaRecorder = new MediaRecorder(stream, options);
                    const timeslice = isIOS ? 100 : 1000;
                    this.mediaRecorder.start(timeslice);
                    this.isRecording = true;
                    this.isProcessingMic = false;

                    this.recordingTime = 0;
                    this.recordingInterval = setInterval(() => {
                        this.recordingTime++;
                    }, 1000);

                    recordingTimeout = setTimeout(() => {
                        if (this.isRecording) {
                            this.stopRecording();
                        }
                    }, maxRecordingDuration);

                    let chunkCounter = 0;
                    this.mediaRecorder.addEventListener('dataavailable', (event) => {
                        if (event.data && event.data.size > 0) {
                            this.audioChunks.push(event.data);
                            chunkCounter++;
                        }
                    });

                    this.mediaRecorder.addEventListener('stop', () => {
                        if (recordingTimeout) {
                            clearTimeout(recordingTimeout);
                        }

                        if (this.isCancellingRecording) {
                            this.isWaitingForAIResponse = false;
                            this.isProcessingMic = false;
                            return;
                        }

                        setTimeout(() => {
                            if (this.isCancellingRecording) {
                                this.isWaitingForAIResponse = false;
                                this.isProcessingMic = false;
                                return;
                            }

                            if (this.audioChunks.length === 0) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'No se grabó audio',
                                    text: 'No se pudo grabar audio. Inténtalo de nuevo.',
                                    confirmButtonColor: '#1d8549',
                                    confirmButtonText: 'Reintentar'
                                });
                                this.isWaitingForAIResponse = false;
                                this.isProcessingMic = false;
                                return;
                            }

                            const audioBlob = new Blob(this.audioChunks, {
                                type: this.mediaRecorder?.mimeType || 'audio/webm'
                            });

                            if (audioBlob.size < 100) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Grabación muy corta',
                                    text: 'La grabación fue muy corta o falló. Inténtalo de nuevo.',
                                    confirmButtonColor: '#1d8549',
                                    confirmButtonText: 'Reintentar'
                                });
                                this.isWaitingForAIResponse = false;
                                this.isProcessingMic = false;
                                return;
                            }

                            this.sendAudioToBackend(audioBlob, `audio_message${fileExtension}`);
                        }, isIOS ? 300 : 200);
                    });

                    this.mediaRecorder.addEventListener('error', (event) => {
                        this.isRecording = false;
                        this.isProcessingMic = false;
                        this.isWaitingForAIResponse = false;

                        if (this.recordingInterval) {
                            clearInterval(this.recordingInterval);
                            this.recordingInterval = null;
                        }

                        if (recordingTimeout) {
                            clearTimeout(recordingTimeout);
                        }

                        Swal.fire({
                            icon: 'error',
                            title: 'Error en la grabación',
                            text: 'Ocurrió un error durante la grabación.',
                            confirmButtonColor: '#1d8549',
                            confirmButtonText: 'Entendido'
                        });
                    });

                } catch (error) {
                    if (this.recordingInterval) {
                        clearInterval(this.recordingInterval);
                        this.recordingInterval = null;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Formato no soportado',
                        text: 'Tu navegador no soporta la grabación con los formatos disponibles.',
                        confirmButtonColor: '#1d8549',
                        confirmButtonText: 'Entendido'
                    });
                    this.isProcessingMic = false;
                    this.isRecording = false;

                    if (this.stream) {
                        this.stream.getTracks().forEach(track => track.stop());
                        this.stream = null;
                    }
                }
            })
            .catch((err) => {
                this.isProcessingMic = false;
                this.isRecording = false;

                if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Permiso denegado',
                        html: '<p>Acceso al micrófono denegado.</p>',
                        confirmButtonColor: '#1d8549',
                        confirmButtonText: 'Entendido'
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error de micrófono',
                        text: 'Error al acceder al micrófono: ' + err.message,
                        confirmButtonColor: '#1d8549',
                        confirmButtonText: 'Entendido'
                    });
                }
            });
    }

    sendAudioToBackend(audioBlob: Blob, filename: string = 'audio_message.webm') {
        if (this.isCancellingRecording) {
            return;
        }

        if (!this.inputOn) {
            this.isWaitingForAIResponse = false;
            this.isProcessingMic = false;

            Swal.fire({
                icon: 'error',
                title: 'Sesión Inválida',
                text: 'No puedes enviar audio sin un token válido.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        if (!audioBlob || audioBlob.size <= 0) {
            this.isWaitingForAIResponse = false;
            this.isProcessingMic = false;

            Swal.fire({
                icon: 'warning',
                title: 'Audio vacío',
                text: 'No se pudo grabar audio.',
                confirmButtonColor: '#1d8549',
                confirmButtonText: 'Reintentar'
            });
            return;
        }

        this.messageAssistanceService.sendAudioToBackend(audioBlob, filename).subscribe({
            next: (response: any) => {
                if (response.success) {
                    this.isWaitingForAIResponse = false;
                    this.isProcessingMic = false;

                    this.newMessageUser = response.data;
                    this.sendMessage();
                } else {
                    this.isWaitingForAIResponse = false;
                    this.isProcessingMic = false;

                    if (response.message) {
                        const mensaje = response.message.toLowerCase();

                        if (mensaje.includes('no te pudimos escuchar') ||
                            mensaje.includes('demasiado corto') ||
                            mensaje.includes('habla más cerca') ||
                            mensaje.includes('claramente') ||
                            mensaje.includes('ruido de fondo') ||
                            mensaje.includes('resultó demasiado corto') ||
                            mensaje.includes('idioma') ||
                            mensaje.includes('español') ||
                            mensaje.includes('inglés')) {

                            Swal.fire({
                                icon: 'warning',
                                title: '¡No te escuchamos!',
                                html: `
                                    <p class="mb-3">El audio resultó demasiado corto o fue afectado por ruido de ambiente.</p>
                                    <div class="text-sm text-gray-600 text-left bg-gray-50 p-3 rounded mt-3">
                                        <p class="font-semibold mb-2">💡 Consejos:</p>
                                        <ul class="space-y-1">
                                            <li>• Habla cerca del micrófono</li>
                                            <li>• Graba por más de 1 segundo</li>
                                            <li>• Evita lugares ruidosos</li>
                                        </ul>
                                    </div>
                                `,
                                confirmButtonColor: '#1d8549',
                                confirmButtonText: 'Intentar de nuevo',
                                allowOutsideClick: false
                            });
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error al procesar',
                                text: response.message,
                                confirmButtonColor: '#1d8549',
                                confirmButtonText: 'Reintentar'
                            });
                        }
                    }
                }
            },
            error: (error) => {
                this.isTyping = false;
                this.isWaitingForAIResponse = false;
                this.isProcessingMic = false;

                let errorTitle = 'Error de conexión';
                let errorMessage = '';
                let iconType: 'error' | 'warning' = 'error';

                if (error.status === 0) {
                    errorTitle = 'Sin conexión';
                    errorMessage = 'No hay conexión con el servidor.';
                    iconType = 'warning';
                } else if (error.status >= 500) {
                    errorTitle = 'Error del servidor';
                    errorMessage = 'El servidor está experimentando problemas.';
                } else {
                    errorMessage = 'No se pudo enviar el audio.';
                }

                Swal.fire({
                    icon: iconType,
                    title: errorTitle,
                    text: errorMessage,
                    confirmButtonColor: '#1d8549',
                    confirmButtonText: 'Entendido'
                });
            }
        });
    }

    onFileSelected(event: any): void {
        const file = event.target.files[0];

        if (file && file.type in this.fileTypeOpt) {
            this.alertService.showAlert(
                'Nota: El envío de archivos no está disponible.',
                'warning'
            );

            this.selectedFile = file;
            this.fileType = this.fileTypeOpt[file.type];
        } else {
            this.alertService.showAlert(
                'El archivo seleccionado no es válido.',
                'warning'
            );
        }

        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
    }

    clearFile(): void {
        this.selectedFile = null;
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
    }

    getFileExtension(filename: string): string {
        const parts = filename.split('.');
        return parts.length > 1
            ? parts[parts.length - 1].toUpperCase()
            : 'UNKNOWN';
    }

    isNearBottom(): boolean {
        const threshold = 80;
        const chatbox = this.chatbox.nativeElement;
        const position = chatbox.scrollTop + chatbox.offsetHeight;
        const height = chatbox.scrollHeight;
        return height - position <= threshold;
    }

    scrollToBottom(): void {
        const chatbox = this.chatbox.nativeElement;
        chatbox.scrollTop = chatbox.scrollHeight;
    }




}
